export type PatientColor = {
  from: string;
  to: string;
  soft: string;
  solid: string;
};

export const PATIENT_COLORS: readonly PatientColor[] = [
  { from: "#2DD4BF", to: "#0D9488", soft: "#F0FDFA", solid: "#14B8A6" }, // teal
  { from: "#06B6D4", to: "#0891B2", soft: "#ECFEFF", solid: "#06B6D4" }, // cyan
  { from: "#10B981", to: "#059669", soft: "#ECFDF5", solid: "#10B981" }, // green
  { from: "#F59E0B", to: "#D97706", soft: "#FFFBEB", solid: "#F59E0B" }, // amber
  { from: "#EF4444", to: "#DC2626", soft: "#FEF2F2", solid: "#EF4444" }, // red
  { from: "#EC4899", to: "#DB2777", soft: "#FDF2F8", solid: "#EC4899" }, // pink
  { from: "#3B82F6", to: "#2563EB", soft: "#EFF6FF", solid: "#3B82F6" }, // blue
];

export function getPatientColor(name: string | null | undefined): PatientColor {
  const first = (name || "?").trim().charAt(0).toUpperCase();
  const code = first.charCodeAt(0) || 0;
  return PATIENT_COLORS[code % PATIENT_COLORS.length];
}

export function patientGradient(color: PatientColor, angle = 135): string {
  return `linear-gradient(${angle}deg, ${color.from} 0%, ${color.to} 100%)`;
}
